import { MustacheFuncs } from '@shared/documents/functions';
import { Editor, Plugin } from 'grapesjs';
import { textStyles } from './layout';

const plugin: Plugin<{}> = (editor: Editor) => {
  const blockManager = editor.BlockManager;
  const domComponents = editor.DomComponents;

  blockManager.add('replace', {
    label: 'Replace',
    content: `<div data-gjs-type="function"></div>`,
    category: 'Functions',
  });

  domComponents.addType('function', {
    model: {
      defaults: {
        tagName: 'div',
        droppable: true,
        draggable: true,
        attributes: { 'data-gjs-type': 'function' },
        styles: textStyles,
        traits: [
          { type: 'string', name: 'replaceTarget', label: 'Replace Target' },
          { type: 'string', name: 'replaceWith', label: 'Replace With' },
        ],
      },
      init() {
        this.listenTo(this, 'change:replaceTarget', this.handleContentChange);
        this.listenTo(this, 'change:replaceWith', this.handleContentChange);
      },
      handleContentChange() {
        this.view.render();
      },
      toHTML: function () {
        const replaceTarget = this.get('traits')?.get('replaceTarget')?.getValue() ?? '';
        const replaceWith = this.get('traits')?.get('replaceWith')?.getValue() ?? '';

        let childrenHtml = '';

        this.components().each((model) => {
          childrenHtml += model.toHTML();
        });

        return mustacheFunction('replace', { replaceTarget, replaceWith }, childrenHtml);
      },
    },
  });

  blockManager.add('func-strings-equal', {
    label: 'Strings Equal',
    content: `<div data-gjs-type="func-strings-equal"></div>`,
    category: 'Functions',
  });

  domComponents.addType('func-strings-equal', {
    model: {
      defaults: {
        tagName: 'div',
        droppable: true,
        draggable: true,
        attributes: { 'data-gjs-type': 'func-strings-equal' },
        styles: textStyles,
        traits: [
          { type: 'string', name: 'stringA', label: 'String A' },
          { type: 'string', name: 'stringB', label: 'String B' },
          { type: 'checkbox', name: 'invert', label: 'Invert Result', default: false },
        ],
      },
      init() {
        this.listenTo(this, 'change:stringA', this.handleContentChange);
        this.listenTo(this, 'change:stringB', this.handleContentChange);
      },
      handleContentChange() {
        this.view.render();
      },
      toHTML: function () {
        const stringA = this.get('traits')?.get('stringA')?.getValue() ?? '';
        const stringB = this.get('traits')?.get('stringB')?.getValue() ?? '';
        const invert = this.get('traits')?.get('invert')?.getValue() ?? false;

        let childrenHtml = '';

        this.components().each((model) => {
          childrenHtml += model.toHTML();
        });

        return mustacheFunction('equal', { stringA, stringB, invert }, childrenHtml);
      },
    },
  });
};

export const mustacheFunction = (func: MustacheFuncs, params: Record<string, unknown>, text = '') => {
  return `{{#_.${func}}}${JSON.stringify([params ?? {}, text])}{{/_.${func}}}`;
};

export default plugin;
